<template>
  <div class="swiperBox" :style="{ position: spos, height: sheight + 'px' }">
    <swiper class="swiper" ref="newsSwiper" :options="swiperOption">
      <swiperSlide v-for="(item, index) in items" :key="index">
        <div class="bannerItem" @click="toUrl(item)" v-if="item.navType == 1">
          <img :src="item.banner" />
        </div>
        <div class="openLaunchWeapp" v-else-if="item.navType == 2">
          <img :src="item.banner" />
          <div class="open-launch-weapp" v-if="!isMiniApp">
            <wx-open-launch-weapp :username="item.miniAppId" :path="item.navLink" @error="handleErrorFn" @launch="handleLaunchFn">
              <script type="text/wxtag-template">
                <style>
                  .btn{
                    padding: 300px 512px;
                    background-color:#ccc;
                    opacity: 0;
                  }
                </style>
                <div class="btn"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <div class="open-launch-weapp" @click.stop="goAppUrl(item.navLink)" v-else></div>
        </div>
        <div class="bannerItem" v-else>
          <img :src="item.banner" />
        </div>
      </swiperSlide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import wx from "weixin-js-sdk";
export default {
  props: {
    items: {
      type: Array,
    },
    spos: {
      type: String,
      default: "relative",
    },
    sheight: {
      type: [Number, String],
      default: "200",
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      info: {},
      swiperOption: {
        direction: "horizontal",
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      }, // banner 轮播设置
      isMiniApp: false,
    };
  },
  created() {
    let _this = this;
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        _this.isMiniApp = true;
      } else {
        _this.isMiniApp = false;
      }
    });
  },
  computed: {},
  methods: {
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn(e) {
      console.log("success", e);
    },
    toUrl(item) {
      if (!item.navLink) {
        return false;
      }
      if (item.navLink.indexOf("http://") < 0 && item.navLink.indexOf("https://") < 0) window.location.href = "https://" + item.navLink;
      else {
        window.location.href = item.navLink;
      }
    },
    goAppUrl(link) {
      if (!link) {
        return false;
      }
      wx.miniProgram.navigateTo({
        url: `/${link}`,
        fail: function () {
          wx.miniProgram.switchTab({ url: `/${link}` });
        },
      });
    },
  },
};
</script>
<style scoped>
.swiperBox {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 4rem;
}
.swiper-pagination {
  bottom: 3px;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiperBox img {
  /* max-width: 100%;
  max-height: 100%; */
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.openLaunchWeapp,
.bannerItem {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
}
.open-launch-weapp {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 4rem;
}
</style>
